export default {
  title: {
    account_index: "Account List"
  },
  button: {
    add_account: "Add Account"
  }
};
